/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { LogicRuleExpressionsInnerFromJSON, LogicRuleExpressionsInnerToJSON } from './LogicRuleExpressionsInner';

/**
 * 
 * @export
 * @interface LogicRule
 */

/**
* @export
* @enum {string}
*/
export var LogicRuleOperatorEnum = /*#__PURE__*/function (LogicRuleOperatorEnum) {
  LogicRuleOperatorEnum["And"] = "and";
  LogicRuleOperatorEnum["Or"] = "or";
  return LogicRuleOperatorEnum;
}({});

/**
 * Check if a given object implements the LogicRule interface.
 */
export function instanceOfLogicRule(value) {
  if (!('operator' in value) || value['operator'] === undefined) return false;
  if (!('expressions' in value) || value['expressions'] === undefined) return false;
  return true;
}
export function LogicRuleFromJSON(json) {
  return LogicRuleFromJSONTyped(json, false);
}
export function LogicRuleFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'operator': json['operator'],
    'expressions': json['expressions'].map(LogicRuleExpressionsInnerFromJSON)
  };
}
export function LogicRuleToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'operator': value['operator'],
    'expressions': value['expressions'].map(LogicRuleExpressionsInnerToJSON)
  };
}